<template>
  <modal :id="modalId">

    <template #header>
      <i class="fa fa-check modal-icon"></i>
      <h4 class="modal-title">{{ title }}</h4>
    </template>

    <form :id="formId" :action="actionUrl" method="POST">

      <slot name="hidden"></slot>
      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">

      <h3 class="text-center mb-4">Are you sure you would like to {{ action }} the timesheet?</h3>

      <slot name="info"></slot>

    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>
      <button type="submit" :name="'button_' + action" class="btn btn-success" :form="formId">
        <i class="fa fa-fw fa-save"></i> {{ capitalizeFirst(action) }}
      </button>
    </template>

  </modal>
</template>

<script>

import HasModal from "../../mixins/HasModal";

export default {

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
    },

    // Form action URL.
    actionUrl: {
      type: String,
      default: "",
    },

    // Action name.
    action: {
      type: String,
      required: true,
    },

    // Form title.
    title: {
      type: String,
      required: false,
    },

  },

  mixins: [HasModal],

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    }

  },

  /**
   * Functions (methods).
   */
  methods: {

    capitalizeFirst(value) {
      if (typeof value === 'string') {
        return value.charAt(0).toUpperCase() + value.slice(1);
      } else {
        console.log('Variable is not a string');
        return value;
      }
    },

  }
}
</script>
